export type ApiMode = 'mock' | 'real' | 'auto';

type RuntimeConfig = {
  VITE_API_BASE_URL?: string;
  VITE_API_MODE?: ApiMode;
  VITE_DISABLE_SIGNUP?: string;
  VITE_FORCE_MOCK_IN_IFRAME?: string;
  VITE_ASSET_PREFIX?: string;
  VITE_APP_BASE_URL?: string;
  NEXT_PUBLIC_API_BASE_URL?: string;
  NEXT_PUBLIC_API_MODE?: ApiMode;
  NEXT_PUBLIC_DISABLE_SIGNUP?: string;
  NEXT_PUBLIC_FORCE_MOCK_IN_IFRAME?: string;
  NEXT_PUBLIC_ASSET_PREFIX?: string;
  NEXT_PUBLIC_APP_BASE_URL?: string;
};

declare let window: {
  __RUNTIME_CONFIG__?: RuntimeConfig;
};

function readEnv(key: string): string | undefined {
  const viteVal = (import.meta.env as Record<string, string | undefined>)?.[key];
  if (viteVal !== undefined) {
    return viteVal;
  }
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    return (
      window.__RUNTIME_CONFIG__[key as keyof RuntimeConfig] ??
      window.__RUNTIME_CONFIG__[key.replace('VITE_', 'NEXT_PUBLIC_') as keyof RuntimeConfig]
    );
  }
  return undefined;
}

export function getRuntimeConfig(): RuntimeConfig {
  return {
    VITE_API_BASE_URL: readEnv('VITE_API_BASE_URL'),
    VITE_API_MODE: readEnv('VITE_API_MODE') as ApiMode | undefined,
    VITE_DISABLE_SIGNUP: readEnv('VITE_DISABLE_SIGNUP'),
    VITE_FORCE_MOCK_IN_IFRAME: readEnv('VITE_FORCE_MOCK_IN_IFRAME'),
    VITE_ASSET_PREFIX: readEnv('VITE_ASSET_PREFIX'),
    VITE_APP_BASE_URL: readEnv('VITE_APP_BASE_URL'),
  };
}

export function isSignupDisabled() {
  const cfg = getRuntimeConfig();
  return cfg.VITE_DISABLE_SIGNUP === 'true';
}
